import action from "../action";
export const SET_SIGN_IN_DETAILS = "SET_SIGN_IN_DETAILS";
export const SET_PASSWORD_RESET_DETAILS = "SET_PASSWORD_RESET_DETAILS";
export const SET_INVITE_TEAMMATE_ARRAY = "SET_INVITE_TEAMMATE_ARRAY";

export const set_sign_in_details = (data) =>
  action({
    type: SET_SIGN_IN_DETAILS,
    data
  });
export const set_password_reset_details = (data) =>
  action({
    type: SET_PASSWORD_RESET_DETAILS,
    data
  });
export const set_invite_teammate_array = (data) =>
  action({
    type: SET_INVITE_TEAMMATE_ARRAY,
    data
  });
